/**
 * Отзыв о враче/клинике
 *
 * @param {Object} params
 * @param {String} params.ratingValue - значение рейтинга
 * @param {String} params.fieldRatingValue - поле со значением рейтинга
 * @param {String} params.setRatingValue - установить значение рейтинга
 * @param {String} params.feedbackForm - форма отправки отзыва
 * @param {String} params.feedbackFormButton - кнопка отправки формы отзыва
 */
$.fn.feedbackForm = function (params) {

    const $self = $(this);
    const $feedbackFormButton = $self.find(params.feedbackFormButton);
    const feedbackForm = params.feedbackForm;
    const ratingValue = params.ratingValue;
    const fieldRatingValue = params.fieldRatingValue;
    const setRatingValue = params.setRatingValue;
    const urlGratitude = $(this).attr('data-url-gratitude');
    const $form = $self.find($(feedbackForm));
    const classError = 'has-error';

    const doctorInput =  $self.find('.js-feedback-form-doctor');
    const doctorInputId = $self.find('.js-feedback-form-doctor-id');
    const clinicInput = $self.find('.js-feedback-form-clinic');
    const doctorList = $self.find('.js-feedback-form-doctor-list');
    const wrapperForm = $('.js-feedback-form');
    const URL_DOCTORS_LIST = '/api/doctors/suggest';
    const doctorButtonArrow = $form.find('.js-feedback-form-arrow');
    let timerId;

    $feedbackFormButton.on('click', function () {
        $feedbackFormButton.prop('disabled', true);
        let value = +$self.find($(fieldRatingValue)).attr(ratingValue);

        if (value === 0) {
            value = null;
        }
        $self.find($(setRatingValue)).val(value);
        let $form = $self.find($(feedbackForm));
        submitForm($form.attr('action'), $form.serialize());
    });

    $(document).on('click', function (event) {
        if (event.target !== doctorInput[0]) {
            doctorList.removeClass('active');
            doctorInput.attr('placeholder', 'Выберите врача')
            doctorButtonArrow.removeClass('active');
            return;
        }
        if (event.target === doctorInput[0]) {
            doctorInput.attr('placeholder', 'Начните набирать ФИО')
            doctorButtonArrow.addClass('active');
        }
    })
    /**
     * очистка формы после успешной отправки
     */
    const clearField = function () {
        $form.find('.js-form-redesign-group').find('input').val('');
        $form.find('.js-rating-value').removeAttr('data-rating');
        $form.find('.js-form-redesign-group').find('textarea').val('');
        const resetCustomSelect = $form.find('.js-clinic-select').data('custom-select').resetCustomSelect;
        resetCustomSelect();
        const resetValue = $form.find('.js-rating').data('rating');
        resetValue(0);
    }
    /**
     * показ ошибок
     */
    const showError = function (listError) {
        for (let errorItem in listError) {
            let errorName = errorItem;
            let errorMessage = listError[errorItem][0];
            const errorInput = $form.find('[name=' + errorName + ']');
            const errorElement = errorInput.closest('.js-form-redesign-group');
            errorElement.addClass(classError);
            const errorField = errorElement.find('.js-field-error');
            errorField.text(errorMessage);
        }
    }
    /**
     * очистка ошибок
     */
    const clearError = function () {
        $form.find('.js-form-redesign-group').removeClass('classError');
        $form.find('.js-field-error').text('');
    }
    /**
     * получить список врачей GET запрос с параметрами ниже
     */

    const getDoctors = function () {
        let doctorInputValue = doctorInput.val();
        let clinicInputValue = clinicInput.find('option:selected').val();
        const data = {
            fio: doctorInputValue,
            clinic_id: clinicInputValue,
        }
        $.ajax({
            method: 'GET',
            url: URL_DOCTORS_LIST,
            data: data,
        }).done(function (data) {
            doctorList.empty();
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    doctorList.append(`<li data-value="${data[i].id}" class="feedback-form-redesign__list-item js-suggest-item">${data[i].fio}</li>`);
                }
                const $doctorListElements = doctorList.find('.js-suggest-item');
                $doctorListElements.on('click', function () {
                    let text = $(this).text();
                    doctorInputValue = text;
                    doctorInput.val(text);
                    doctorInputId.val($(this).attr('data-value'));
                    doctorList.removeClass('active');
                })
            } else {
                doctorList.append(`<li data-value="" class="feedback-form-redesign__list-item js-suggest-item">Врачи не найдены</li>`);
            }
        })
    }
    /**
     * получения value и запрос получения списка докторов
     */
    doctorInput.on('input focus', function () {
        doctorList.addClass('active')
        if (timerId) {
            return;
        }
        timerId = setTimeout(function () {
            getDoctors()
            timerId = '';
        }, 300)
    })

    /**
     * Отправка формы
     */
    const submitForm = function (url, data) {
        clearError();
        $.ajax({
            method: 'POST',
            url: url,
            data: data
        }).done(function (data) {
            if (data.success) {
                wrapperForm.addClass('success');
                clearField();
                setTimeout(function (){
                    wrapperForm.removeClass('success');
                    $feedbackFormButton.prop('disabled', false);
                }, 4000)
            } else {
                showError(data.error.message);
                $feedbackFormButton.prop('disabled', false);
            }
        }).fail(function (error) {
            $feedbackFormButton.prop('disabled', false);
        });

    };

    return this;
};

const init = function () {

    $('#feedback-form-module').feedbackForm({
        ratingValue: 'data-rating',
        fieldRatingValue: '[data-field-rating-value="true"]',
        setRatingValue: '[data-set-rating-value="true"]',
        feedbackForm: '[data-feedback-form="true"]:first',
        feedbackFormButton: $('[data-feedback-form-button="true"]'),
    });
};

if ($('#feedback-form-module').length > 0) {
    init();
}
